import { Spinner, Surface } from '@vst/beam';
import { useTranslation } from 'react-i18next';

const CalendarLoading = () => {
  const { t } = useTranslation('ScheduleInstallation');

  return (
    <Surface>
      <Spinner description={t('calendar.loading')} />
    </Surface>
  );
};

export default CalendarLoading;
